// extracted by mini-css-extract-plugin
export var createdDate = "_lw-1";
export var divider = "_lw-2";
export var headerDivider = "_lw-3";
export var messagesCard = "_lw-0";
export var messagesContainer = "_lw-7";
export var messagesContainerWrapper = "_lw-4";
export var pointerCapturingButtonBoxes = "_lw-a";
export var showLeftPanelButton = "_lw-9";
export var showMoreButton = "_lw-c";
export var showMoreButtonContainer = "_lw-b";
export var summaryTitle = "_lw-6";
export var systemMessageCardWrapper = "_lw-d";
export var topButtons = "_lw-8";
export var withPadding = "_lw-5";